export default "/packs/images/carabiner-2~84521ed064213ab0e11203ec1395e931.png";